'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
function mergeClassNames(a, b) {
  if (a && b) {
    return a + ' ' + b;
  }

  // Either a or b at this point
  return (a || '') + (b || '');
}

exports.default = mergeClassNames;


//////////////////
// WEBPACK FOOTER
// ./~/reactabular-utils/dist/merge-class-names.js
// module id = 641
// module chunks = 0